export const getCountryName = countryCode =>
  APRICOT.data.countries.find(({ iso }) => iso.toUpperCase() === countryCode)?.name
